/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
import type { Status } from './Status.js';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status.js';

/**
 * Patch Notification
 * @export
 * @interface NotificationPatch
 */
export interface NotificationPatch {
    /**
     * 
     * @type {Status}
     * @memberof NotificationPatch
     */
    status: Status;
}

/**
 * Check if a given object implements the NotificationPatch interface.
 */
export function instanceOfNotificationPatch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function NotificationPatchFromJSON(json: any): NotificationPatch {
    return NotificationPatchFromJSONTyped(json, false);
}

export function NotificationPatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': StatusFromJSON(json['status']),
    };
}

export function NotificationPatchToJSON(value?: NotificationPatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': StatusToJSON(value.status),
    };
}

